// Nav functionality
const localeBoxes = document.querySelectorAll(".locale_box");
const localeInfo = document.querySelectorAll(".locale_info");
const localeOptions = document.querySelectorAll("#local-options option");
const localeTabs = document.querySelectorAll("#locale-nav-tabs a");
const localeOptionNav = document.getElementById("locale-options");

const toggleNav = function (e) {
  e.preventDefault();
  let locale;

  // Reset all nav indicators
  localeInfo.forEach((info) => info.classList.add("hidden"));
  localeOptions.forEach((option) => option.removeAttribute("selected"));
  localeTabs.forEach((tab) => tab.classList.remove("active"));
  localeBoxes.forEach((box) => box.classList.remove("active"));

  // Set the new nav indicator
  if (e.target.nodeName === "SELECT") {
    // If the user clicked on the select box
    locale = e.target.value.toLowerCase();
  } else {
    // If the user clicked on the nav tab or SVG
    locale = e.target.dataset.locale ? e.target.dataset.locale : "setouchi";
  }
  localeOptionNav.value = locale.replace(/\w/, (firstLetter) =>
    firstLetter.toUpperCase()
  ); // Set the select box to the correct value (capitalized)
  document
    .querySelector(`#locale-nav-tabs a[data-locale="${locale}"]`)
    ?.classList.add("active");
  document
    .querySelector(`.locale_box[data-locale="${locale}"]`)
    ?.classList.add("active");

  // Reveal the locale info
  document.getElementById(`${locale}_info`).classList.remove("hidden");
};

// Init Nav
const localeSVG = document.getElementById("locale_svg");
const localeTabNav = document.getElementById("locale-nav-tabs");

[localeSVG, localeTabNav].forEach((nav) => {
  nav.addEventListener("click", (e) => toggleNav(e));
});

localeOptionNav.addEventListener("change", (e) => toggleNav(e));

// Nav thumbnail functionality
const imgContainer = document.getElementById("image_container");
const mapContainer = document.getElementById("map_container");
const thumbnailGalleries = document.querySelectorAll(".locale-thumbnails");
thumbnailGalleries.forEach((thumbnailGallery) => {
  thumbnailGallery.addEventListener("mouseover", (e) => {
    if (e.target.nodeName === "IMG") {
      const thumbnailUrl = e.target.currentSrc;
      mapContainerHeight = mapContainer.offsetHeight;
      mapContainer.classList.add("hidden");
      imgContainer.classList.remove("hidden");
      imgContainer.querySelector("img").src = thumbnailUrl.replace(
        "@0.25x",
        ""
      );
      imgContainer.style.height = mapContainerHeight + "px";
    }
  });
  thumbnailGallery.addEventListener("mouseout", (e) => {
    if (e.target.nodeName === "IMG") {
      mapContainer.classList.remove("hidden");
      imgContainer.classList.add("hidden");
    }
  });
});
